
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 37 32"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"matrix(0.439832, 0, 0, 0.436097, -90.242256, -64.960144)"}},[_c('polyline',{staticStyle:{"fill":"none","stroke":"currentColor","stroke-width":"5px","stroke-linecap":"round"},attrs:{"points":"261.806 173.066 261.806 160.339 220.491 160.339 209.455 171.375 220.643 182.563"}}),_c('line',{staticStyle:{"stroke-width":"5px","stroke":"currentColor"},attrs:{"x1":"241.102","y1":"158.758","x2":"241.102","y2":"150.143"}}),_c('polygon',{staticStyle:{"fill":"rgb(216, 216, 216)","stroke":"rgb(0, 0, 0)"},attrs:{"points":"246.155 187.154"}}),_c('polygon',{staticStyle:{"fill":"none","stroke-width":"5px","stroke":"currentColor"},attrs:{"points":"233.732 183.725 274.413 183.725 284.768 194.08 274.63 204.218 233.793 204.218"}}),_c('line',{staticStyle:{"stroke-width":"5px","stroke":"currentColor"},attrs:{"x1":"241.245","y1":"204.382","x2":"241.245","y2":"221.637"}})])])
          )
        }
      }
    